module.exports = __webpack_public_path__ + "static/artefact-f918adefe3d6323245f45ffaeb3bf4b0.png";